import { AlertTriangle } from 'lucide-react';
import React from 'react';
import { useSelector } from 'react-redux';
import propTypes from 'prop-types';
import {
  APPOINTED_CARRIERS_TAB_ID,
  getParentGroupLabel,
  getParentGroupTabId
} from 'helpers/carriers/carriers';
import Tabs from 'tailwind-components/Tabs/Tabs';

export default function AppointmentTabs({
  currentTab,
  setCurrentTab,
  handleResetActiveCarrier = () => {},
  includeActionableTab = false
}) {
  const { carriersArray, actionableAppointments } = useSelector(
    state => state.appointments
  );

  const hasActionableAppts = actionableAppointments.length > 0;

  const parentAppointmentGroups = new Set();

  carriersArray
    .filter(carrier => !!carrier.appointmentParentGroup)
    .forEach(carrier => {
      parentAppointmentGroups.add(carrier.appointmentParentGroup);
    });

  const tabList = [
    {
      id: APPOINTED_CARRIERS_TAB_ID,
      label: 'Appointed Carriers',
      filterKey: APPOINTED_CARRIERS_TAB_ID
    },
    ...[...parentAppointmentGroups].map(group => ({
      id: getParentGroupTabId(group),
      label: getParentGroupLabel(group)
    })),
    ...(hasActionableAppts && includeActionableTab
      ? [
          {
            id: 'action-needed',
            label: 'Action Needed',
            icon: <AlertTriangle size={14} />,
            className: 'text-semantic-danger',
            activeClassName: 'text-semantic-danger bg-semantic-danger/15'
          }
        ]
      : []),
    { id: 'by-state', label: 'By State', dataTour: 'carrier-appt-by-state-tab' }
  ];

  return (
    <Tabs
      tabs={tabList}
      activeTabId={currentTab}
      onTabChange={id => {
        setCurrentTab(id);
        if (id !== 'action-needed') handleResetActiveCarrier();
      }}
      buttonClassName='font-medium'
      scrollButtons
      className='max-lg:justify-between'
    />
  );
}

AppointmentTabs.propTypes = {
  currentTab: propTypes.string.isRequired,
  setCurrentTab: propTypes.func.isRequired,
  handleResetActiveCarrier: propTypes.func,
  includeActionableTab: propTypes.bool
};
